

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './other/interceptor'

const app = createApp(App)


app.use(router)
app.component()
app.mount('#app')


